import React from 'react';
import ProductNavigation from 'common/components/shop/ProductNavigation';
import { IntlProvider } from 'common/components/Intl';

export default function ProductNavigationContainer(props) {
  return (
    <IntlProvider>
      <ProductNavigation {...props} />
    </IntlProvider>
  );
}
